import { configureStore } from "@reduxjs/toolkit";

import uiReducer from "./uiReducer";
import sensorReducer from "./sensorReducer";
import { sensorsMiddleware } from "./sensorsMiddleware";

// `auth` and `consumer` slices were removed with the admin/consumer cleanup —
// no live components subscribe to them.
export const store = configureStore({
  reducer: {
    ui: uiReducer,
    sensor: sensorReducer,
  },
  // We store classes in the sensor slice, so the default serializable check
  // would warn on every dispatch.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).prepend(sensorsMiddleware.middleware),
});
